(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["range-filter"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const primaryRadios = document.querySelectorAll('input[name="primary-color"]');
  const secondarySwatches = document.querySelectorAll('#secondary-swatches .swatch');
  const secondaryRadios = document.querySelectorAll('input[name="secondary-color"]');
  const accentGroup = document.getElementById('accent-group');
  const searchButton = document.getElementById('searchButton');

  function updateButtonVisibility() {
    const primarySelected = document.querySelector('input[name="primary-color"]:checked');
    const secondarySelected = document.querySelector('input[name="secondary-color"]:checked');
    if (primarySelected && secondarySelected) searchButton.classList.add('visible');
    else searchButton.classList.remove('visible');
  }

  function updateAccentSwatches(primaryValue) {
    secondarySwatches.forEach(swatch => {
      const input = swatch.querySelector('input');
      if (!input) return;
      const allowedBases = input.dataset.attachBases
        ? input.dataset.attachBases.split(',').map(b => b.trim().toLowerCase())
        : [];
      if (allowedBases.includes(primaryValue)) {
        swatch.classList.remove('hidden', 'disabled');
        input.disabled = false;
      } else {
        swatch.classList.add('hidden', 'disabled');
        input.checked = false;
        input.disabled = true;
      }
    });
  }

  primaryRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      accentGroup.classList.add('visible');
      updateAccentSwatches(radio.value);
      secondaryRadios.forEach(r => r.checked = false);
      updateButtonVisibility();
    });
  });

  secondaryRadios.forEach(radio => {
    radio.addEventListener('change', updateButtonVisibility);
  });

  searchButton.addEventListener('click', () => {
    const primary = document.querySelector('input[name="primary-color"]:checked');
    const secondary = document.querySelector('input[name="secondary-color"]:checked');
    if (!primary || !secondary) { alert('Please select both colors!'); return; }
    const key = `${primary.value}-${secondary.value}`;
    const url = window.colorLinkMap[key.toLowerCase()];
    if (url) window.location.href = url;
    else console.warn('No link configured for:', key);
  });
});

  } catch(e) { console.error(e); }
})();
})();
